import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import InstallationOuvragePanel from 'installation/components/installations/components/InstallationOuvragePanel'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'

const ModalOuvrage = ({
    ouvrage,
    open,
    onCancel,
    onValidate,
    surveyMode,
}) => {
    const [newOuvrage, setNewOuvrage] = useState(ouvrage)
    const onChangeValue = (obj) => {
        setNewOuvrage(prev => ({ ...prev, ...obj }))
    }

    const onClose = () => {
        setNewOuvrage(ouvrage)
        onCancel()
    }

    return (
        <Dialog
            onClose={onClose}
            fullWidth
            maxWidth='md'
            open={open}
        >
            <DefaultDialogTitle title={i18n.updateWork} onClose={onClose} />
            <DialogContent>
                <InstallationOuvragePanel
                    work={newOuvrage}
                    onChange={onChangeValue}
                    surveyMode={surveyMode}
                />
            </DialogContent>
            <DialogActions >
                <Button onClick={onClose} variant='outlined' color='primary'>
                    {i18n.cancel}
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ModalOuvrage.propTypes = {
    surveyMode: PropTypes.bool,
    open: PropTypes.bool,
    ouvrage: PropTypes.instanceOf({}),
    onCancel: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
}

export default ModalOuvrage